import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
const VIDEO_URL = 'https://i.imgur.com/Omfv5ra.mp4';
export function TourSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const handleLoaded = () => {
      video.playbackRate = 0.7;
    };
    video.addEventListener('loadedmetadata', handleLoaded);
    return () => video.removeEventListener('loadedmetadata', handleLoaded);
  }, []);
  return <section id="recorrido" className="relative h-[70vh] md:h-[88vh] min-h-[520px] overflow-hidden flex items-center justify-center" data-id="element-510" data-mp="1j16p1scon11y">
      <div className="absolute inset-0 z-0" data-id="element-511" data-mp="1ntqatclix2hu">
        <video ref={videoRef} className="w-full h-full object-cover opacity-60" autoPlay muted loop playsInline data-id="element-512" data-mp="1ssku0fnekt2h">
          <source src={VIDEO_URL} type="video/mp4" data-id="element-513" data-mp="21sgbf27jxkay" />
        </video>
      </div>
      <div className="absolute inset-0 z-[1] bg-gradient-to-b from-night/65 via-night/25 to-night/65" data-id="element-514" data-mp="21qdb9pcoqasi" />
      
      <motion.div initial={{
      opacity: 0,
      y: 35
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-40px'
    }} transition={{
      duration: 0.8
    }} className="relative z-[2] text-center px-8 max-w-[800px]" data-id="element-515" data-mp="3ia7ahvr3rx7k">
        <span className="inline-block text-[0.67rem] font-semibold tracking-[0.3em] uppercase text-gold-light mb-6" data-id="element-516" data-mp="38dkv3mhjpycx">
          El Refugio por Dentro
        </span>
        <h2 className="font-display text-[2.5rem] sm:text-[6vw] lg:text-5xl font-light text-white leading-[1.05] mb-6 drop-shadow-[0_2px_20px_rgba(0,0,0,0.4)]" data-id="element-517" data-mp="4v1a95175us5">
          Un recorrido que<br data-id="element-518" data-mp="3rb5ggjl3qess" />
          <em className="italic text-gold-light" data-id="element-519" data-mp="3rbnmu91ha9ef">te enamora</em>
        </h2>
        <p className="text-base sm:text-lg text-white font-medium leading-[1.75] mb-8 drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]" data-id="element-520" data-mp="skvkrfy1n798">
          Antes de llegar, siéntelo. Cada rincón de Refugio Caracolí fue construido para que no quieras irte.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap mb-8" data-id="element-521" data-mp="2i3c277kbdi1z">
          {['9 Cabañas Únicas', 'Piscina · Sauna · Gym', 'Pet Friendly', 'A 30 min de Ibagué'].map(pill => <span key={pill} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-5 py-2 text-[0.72rem] tracking-[0.08em] text-white/85" data-id="element-522" data-mp="28bel5k6mjvvc">
              {pill}
            </span>)}
        </div>
        <a href="#reserva" className="inline-flex items-center gap-2 bg-gold text-night px-7 py-3.5 rounded-full text-xs font-semibold tracking-wide uppercase transition-all hover:bg-gold-light hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(201,169,110,0.45)]" data-id="element-523" data-mp="23dmko1rwz1fj">
          Quiero Vivir Esto
        </a>
      </motion.div>
    </section>;
}